import Layout from '@/components/layout/index.vue'

export default {
  path: 'orderpurchase',
  name: 'Orderpurchase',
  meta: {},
  component: Layout,
  redirect: { name: 'Orderpurchase.Labelprinting' },
  children: [
    {
      path: 'labelprinting',
      name: 'Orderpurchase.Labelprinting',
      meta: {},
      component: () => import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/labelprinting/index.ts')
    },
    {
      path: 'orderchange',
      name: 'Orderpurchase.Orderchange',
      meta: {},
      component: () => import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/orderchange/index.ts')
    },
    {
      path: 'productionreport',
      name: 'Orderpurchase.Productionreport',
      meta: {},
      component: () => import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/productionreport/index.ts')
    },
    {
      path: 'ordertrack',
      name: 'Orderpurchase.Ordertrack',
      meta: {},
      component: () => import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/ordertrack/index.ts')
    },
    {
      path: 'purchasereply',
      name: 'Orderpurchase.Purchasereply',
      meta: {},
      component: () => import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/purchasereply/index.ts')
    },
    {
      path: 'externalcontrol',
      name: 'Orderpurchase.Externalcontrol',
      meta: {},
      component: () => import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/externalcontrol/index.ts')
    },
    {
      path: 'outorderissue',
      name: 'Orderpurchase.Outorderissue',
      meta: {},
      component: () => import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/outorderissue/index.ts')
    }
  ]
}
